// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".box[data-v-06341a08] {\n  padding-top: 14px;\n  position: relative;\n  margin-bottom: 14px;\n}\n.box .title[data-v-06341a08] {\n    text-align: center;\n    margin-bottom: 30px;\n    font-size: 15px;\n    font-weight: 500;\n    color: #000;\n}\n[data-v-06341a08] .el-dialog__header {\n  border-bottom: none;\n}\n[data-v-06341a08] .el-form-item__label {\n  font-size: 14px;\n  font-weight: 400;\n  color: #333333;\n}\n", ""]);
// Exports
module.exports = exports;
